export default __webpack_public_path__ + "static/media/gw.7173131b.png";